import { HBO, TOOLBOX_MAP, WIDEVINE_DRM } from 'containers/Player/constants';
import { getBrowser } from 'utils/Platform';

const fetchCertificate = (certificateUrl, providerCode, streamType, mediaCertificates, isLive) => {
  if(!isLive && TOOLBOX_MAP[providerCode]){
      if (certificateUrl) {
    return fetch(certificateUrl);
  }
  return

  }
  if (!isLive && providerCode.includes(HBO) && streamType.includes(WIDEVINE_DRM)) {
    return new Promise((resolve, reject) => reject());
  }

  const browser = getBrowser();
  if(!isLive && browser.indexOf('Safari') > -1 && providerCode.includes(HBO)){
    const providers = JSON.parse(mediaCertificates).default;
    const { url } = providers[providerCode][streamType];
    return fetch(certificateUrl);
  }

  if (certificateUrl) {
    return fetch(certificateUrl);
  }
  const providers = mediaCertificates.default;
  const { url } = providers[providerCode][streamType];
  return fetch(url);
};

export default fetchCertificate;
